import { useTranslation } from "react-i18next";
import type { BookingStatus } from "./api";

export const STATUS_COLORS: Record<BookingStatus, string> = {
  inquiry:    "#f59e0b",
  booked:     "#10b981",
  processing: "#3b82f6",
  completed:  "#8b5cf6",
  cancelled:  "#94a3b8",
};

export function useStatusLabels(): Record<BookingStatus, string> {
  const { t } = useTranslation();
  return {
    inquiry:    t("bookings.status.inquiry"),
    booked:     t("bookings.status.booked"),
    processing: t("bookings.status.processing"),
    completed:  t("bookings.status.completed"),
    cancelled:  t("bookings.status.cancelled"),
  };
}
